<template>
  <b-form @submit.prevent="submitTwoFactor">
    <div class="mb-4">
      <h5 class="font-weight-bold text-dark mb-1 rrd-auth-title">Check your email</h5>
      <p class="rrd-auth-subtitle mb-0">
        We have sent a verification code to your email address.<br />
        Please enter the <span class="text-dark font-weight-bold">6-digit code</span> below.
      </p>
    </div>

    <b-form-group class="mb-4">
      <label class="rrd-label">Verification Code</label>

      <b-form-input
        ref="codeInput"
        v-model.trim="twoFactorCode"
        :state="twoFactorCodeState"
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        maxlength="6"
        autocomplete="one-time-code"
        aria-describedby="inputTwoFactorFeedback"
        placeholder="------"
        class="rrd-input rrd-otp"
        @input="onCodeInput"
      />

      <b-form-invalid-feedback id="inputTwoFactorFeedback">
        Please enter the valid code
      </b-form-invalid-feedback>
    </b-form-group>

    <b-button type="submit" block class="rrd-btn-primary text-uppercase  mb-3">
      Verify Code
    </b-button>

    <div class="text-center">
      <p class="small text-muted mb-0">
        Didn't receive the code?
        <a href="#" @click.prevent="resendTwoFactor" class="rrd-link-strong">Resend</a>
      </p>
    </div>
  </b-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { toast } from '@/shared/plugins/toastr'
import routeNames from '@/router/routeNames'
import { INSTITUTION_USER, INSTITUTION_VIEW_USER } from '@/shared/constants'

export default {
  name: 'TwoFactorForm',
  props: {
    userId: { type: Number },
  },
  data() {
    return {
      twoFactorCode: '',
      twoFactorCodeState: null,
    }
  },
  validations: {
    twoFactorCode: { required },
  },
  mounted() {
    // fokus odmah na input
    this.$nextTick(() => {
      if (this.$refs.codeInput && this.$refs.codeInput.focus) this.$refs.codeInput.focus()
    })
  },
  methods: {
    onCodeInput(v) {
      // samo brojevi, max 6
      const cleaned = String(v || '').replace(/\D/g, '').slice(0, 6)
      if (cleaned !== this.twoFactorCode) this.twoFactorCode = cleaned
      this.twoFactorCodeState = null
    },

    async submitTwoFactor() {
      this.twoFactorCodeState = null

      if (this.$v.twoFactorCode.$invalid || String(this.twoFactorCode).length !== 6) {
        this.twoFactorCodeState = false
        return
      }
      this.twoFactorCodeState = true

      this.$store
        .dispatch('auth/actionVerifyTwoFactorCode', { id: this.userId, code: this.twoFactorCode })
        .then(() => {
          this.$store.dispatch('user/actionSetUser').then((userResponse) => {
            if (userResponse.role.id === INSTITUTION_USER || userResponse.role.id === INSTITUTION_VIEW_USER) {
              this.$store.dispatch('institution/actionSetInstitution', userResponse.institution.id)
            }
            this.$store
              .dispatch('user/actionSetUserPermissions')
              .then(() => toast({ title: 'Login successful', type: 'success' }))
              .finally(() => this.$router.replace({ name: routeNames.RN_DASHBOARD }))
          })
        })
        .catch(() => {
          this.twoFactorCodeState = false
          toast({
            title: 'Verification failed',
            message: 'The code you entered is incorrect.',
            type: 'error',
          })
        })
    },

    async resendTwoFactor() {
      // TODO: pozovi backend kad bude spremno
      toast({ title: 'Code resent', type: 'info' })
    },
  },
}
</script>

<style scoped>
/* samo lokalno za 2FA, ostalo koristi isti sistem kao Login */
.rrd-auth-title {
  font-size: 1.05rem;
}

.rrd-auth-subtitle {
  font-size: 0.9rem;
  line-height: 1.5;
  color: #667085;
}

/* OTP input look */
.rrd-otp {
  height: 52px;
  text-align: center;
  font-size: 18px;
  letter-spacing: 6px;
}

/* fallback ako nema globalnih klasa u ovom fajlu */
.rrd-label {
  display: block;
  margin: 0 0 6px 0;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #667085;
}

.rrd-input {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #fff;
}

.rrd-input:focus {
  border-color: #0a73b7;
  box-shadow: 0 0 0 0.2rem rgba(10, 115, 183, 0.12);
}

.rrd-btn-primary {
  border-radius: 10px;
  border: 1px solid #008fd5;
  background: #008fd5;
  color: #fff;
  letter-spacing: 0.04em;
}

.rrd-btn-primary:hover {
  background: #007fbe;
  border-color: #007fbe;
}

.rrd-btn-primary:focus {
  box-shadow: 0 0 0 0.25rem rgba(0, 143, 213, 0.22);
}

.rrd-link-strong {
  font-weight: 800;
  color: #008fd5;
  text-decoration: none;
}

.rrd-link-strong:hover {
  text-decoration: underline;
}
</style>
